module.exports = __webpack_public_path__ + "images/gazellea37547d07af6687e7b71e38415891d09.png";